import { Image } from "@fla/components";
import { useAppDispatch } from "app/store";
import Logo from "assets/images/logo-1x.webp";
import Logo3x from "assets/images/logo-3x.webp";
import classNames from "classnames";
import { selectUserProfile, userActions } from "pages/User";
import LoginModal from "pages/User/Login/LoginModal";
import { FC } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

export const TopNavigation: FC<{ shadow?: boolean; sticky?: boolean; bgColor?: string }> = ({
  shadow = false,
  sticky = true,
  bgColor = "bg-main"
}) => {
  const { pathname } = useLocation();
  const user = useSelector(selectUserProfile);
  const dispatch = useAppDispatch();

  const onLogout = () => dispatch(userActions.logout());

  if (pathname === "/get-started") {
    return (
      <article
        className={classNames(
          "h-20 flex items-center px-5 justify-between",
          {
            "shadow-md bg-white": shadow,
            "sticky top-0 left-0 z-50": sticky
          },
          bgColor
        )}
      >
        <Link to="/">
          <Image width="11rem" className="w-32 h-auto" placeholderSrc={Logo} src={Logo3x} />
        </Link>
        {user?.uid ? (
          <div className="flex items-center space-x-2">
            <button
              className="bg-primary/20 text-primary hover:bg-primary hover:text-white rounded-lg px-5 py-2"
              onClick={onLogout}
            >
              <p className="text-sm font-bold uppercase">LOG OUT</p>
            </button>
          </div>
        ) : (
          <LoginModal />
        )}
      </article>
    );
  }

  return (
    <article
      className={classNames(
        "h-20 flex items-center px-5 justify-between",
        {
          "shadow-md bg-white": shadow,
          "sticky top-0 left-0 z-50": sticky
        },
        bgColor
      )}
    >
      <Link to="/">
        <Image width="11rem" className="w-32 h-auto" placeholderSrc={Logo} src={Logo3x} />
      </Link>
      <button
        className="bg-primary/20 text-primary hover:bg-primary hover:text-white rounded-lg px-5 py-2"
        onClick={onLogout}
      >
        <p className="text-sm font-bold uppercase">LOG OUT</p>
      </button>
    </article>
  );
};
